import React from 'react';
import { connect } from 'react-redux';
import { PatientCareCenterNoteSection } from 'PatientCareCenter/Note';
import styles from './Motivation.module.css';
import { DBRadioButton } from '_components';


class PatientCareCenterNoteSubjectiveMotivation extends React.Component {

    render() {
        return (
            <PatientCareCenterNoteSection id='sub_motivation' name='Motivation' level={1} className={this.props.isWc ? styles.required : ''}>
                <div className={styles.row}>
                    <span className={styles.col1} />
                    <DBRadioButton
                        noteId={this.props.noteId}
                        entity='PTEVAL'
                        entityKeyColumn='EVNO'
                        entityKeyValue={this.props.evno}
                        field='EVSUBMOTIVATION'
                        label='Motivated'
                        selectedValue='Motivated'
                        className={styles.col2}
                    />
                </div>

                <div className={styles.row}>
                    <span className={styles.col1} />
                    <DBRadioButton
                        noteId={this.props.noteId}
                        entity='PTEVAL'
                        entityKeyColumn='EVNO'
                        entityKeyValue={this.props.evno}
                        field='EVSUBMOTIVATION'
                        label='Not Motivated'
                        selectedValue='Not Motivated'
                        className={styles.col2}
                    />
                </div>
            </PatientCareCenterNoteSection>
        );
    }

}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let evno = parseInt(noteId.split("_")[1]);
    let isWc = state.entities.admissions[state.entities.notes.PTEVAL[evno].EVEPNO].isWc;

    return {
        noteId: noteId,
        evno: evno,
        isWc
    };
}

const connectedPatientCareCenterNoteSubjectiveMotivation = connect(mapStateToProps)(PatientCareCenterNoteSubjectiveMotivation);
export { connectedPatientCareCenterNoteSubjectiveMotivation as PatientCareCenterNoteSubjectiveMotivation };

